"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importFundImpactsValidation = exports.importFundImpactsFyDownloadsValidation = exports.importFundImpactsFyDownloads = exports.importFundImpactsFyAssetsValidation = exports.importFundImpactsFyAssets = exports.importFundImpacts = exports.fundImpactsValidationErrorDownload = exports.fundImpactsFyDownloadsValidationErrorDownload = exports.fundImpactsFyAssetsValidationErrorDownload = exports.fundImpactImportSuccess = exports.fundImpactImportReset = exports.fundImpactImportError = void 0;
var _fundImpactImport = require("./fundImpactImport.constant");
// @flow

// common success
var fundImpactImportSuccess = function fundImpactImportSuccess(actionType, data) {
  return {
    type: _fundImpactImport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.fundImpactImportSuccess = fundImpactImportSuccess;
var fundImpactImportError = function fundImpactImportError(actionType, error) {
  return {
    type: _fundImpactImport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * import validation
 * @param payload
 * @returns api response
 * @description this function used to import validation data.
 */
exports.fundImpactImportError = fundImpactImportError;
var importFundImpactsValidation = function importFundImpactsValidation(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS_VALIDATION,
    payload: data
  };
};

/**
 * import
 * @param payload
 * @returns api response
 * @description this function used to import data.
 */
exports.importFundImpactsValidation = importFundImpactsValidation;
var importFundImpacts = function importFundImpacts(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS,
    payload: data
  };
};

/**
 * validation error download
 * @param payload
 * @returns api response
 * @description this function used to validation error download.
 */
exports.importFundImpacts = importFundImpacts;
var fundImpactsValidationErrorDownload = function fundImpactsValidationErrorDownload(data) {
  return {
    type: _fundImpactImport.actionTypes.FUND_IMPACTS_VALIDATION_ERROR_DOWNLOAD,
    payload: data
  };
};

/**
 * import fy downloads validation
 * @param payload
 * @returns api response
 * @description this function used to import fy downloads validation.
 */
exports.fundImpactsValidationErrorDownload = fundImpactsValidationErrorDownload;
var importFundImpactsFyDownloadsValidation = function importFundImpactsFyDownloadsValidation(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS_FY_DOWNLOADS_VALIDATION,
    payload: data
  };
};

/**
 * import fy downloads
 * @param payload
 * @returns api response
 * @description this function used to import fy downloads.
 */
exports.importFundImpactsFyDownloadsValidation = importFundImpactsFyDownloadsValidation;
var importFundImpactsFyDownloads = function importFundImpactsFyDownloads(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS_FY_DOWNLOADS,
    payload: data
  };
};

/**
 * fy downloads validation error download
 * @param payload
 * @returns api response
 * @description this function used to fy downloads validation error download data.
 */
exports.importFundImpactsFyDownloads = importFundImpactsFyDownloads;
var fundImpactsFyDownloadsValidationErrorDownload = function fundImpactsFyDownloadsValidationErrorDownload(data) {
  return {
    type: _fundImpactImport.actionTypes.FUND_IMPACTS_FY_DOWNLOADS_VALIDATION_ERROR_DOWNLOAD,
    payload: data
  };
};

/**
 * import assets validation
 * @param payload
 * @returns api response
 * @description this function used to import assets validation.
 */
exports.fundImpactsFyDownloadsValidationErrorDownload = fundImpactsFyDownloadsValidationErrorDownload;
var importFundImpactsFyAssetsValidation = function importFundImpactsFyAssetsValidation(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS_FY_ASSETS_VALIDATION,
    payload: data
  };
};

/**
 * import assets
 * @param payload
 * @returns api response
 * @description this function used to import assets.
 */
exports.importFundImpactsFyAssetsValidation = importFundImpactsFyAssetsValidation;
var importFundImpactsFyAssets = function importFundImpactsFyAssets(data) {
  return {
    type: _fundImpactImport.actionTypes.IMPORT_FUND_IMPACTS_FY_ASSETS,
    payload: data
  };
};

/**
 * fy assets validation error download
 * @param payload
 * @returns api response
 * @description this function used to fy assets validation error download.
 */
exports.importFundImpactsFyAssets = importFundImpactsFyAssets;
var fundImpactsFyAssetsValidationErrorDownload = function fundImpactsFyAssetsValidationErrorDownload(data) {
  return {
    type: _fundImpactImport.actionTypes.FUND_IMPACTS_FY_ASSETS_VALIDATION_ERROR_DOWNLOAD,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.fundImpactsFyAssetsValidationErrorDownload = fundImpactsFyAssetsValidationErrorDownload;
var fundImpactImportReset = function fundImpactImportReset() {
  return {
    type: _fundImpactImport.actionTypes.RESET
  };
};
exports.fundImpactImportReset = fundImpactImportReset;